import { REMOVE_DNO_ITEMS_FAILURE, REMOVE_DNO_ITEMS_REQUEST, REMOVE_DNO_ITEMS_RESET, REMOVE_DNO_ITEMS_SUCCESS } from "redux/actions/action-type"


const initialState = {
    isRemoveDNOLoading: false,
    isRemoveDNOSuccess: false,
    isRemoveDNOFail: false,
    removeDNOResponse: {}
}

export const removeDoNotOrderItemsReducer = (state = initialState, { type, removeDNOResponse }) => {
    switch (type) {
        case REMOVE_DNO_ITEMS_REQUEST:
            return {
                ...state,
                isRemoveDNOLoading: true,
                isRemoveDNOSuccess: false,
                isRemoveDNOFail: false
            }
        case REMOVE_DNO_ITEMS_SUCCESS:
            return {
                ...state,
                removeDNOResponse: removeDNOResponse,
                isRemoveDNOLoading: false,
                isRemoveDNOSuccess: true,
                isRemoveDNOFail: false
            }
        case REMOVE_DNO_ITEMS_FAILURE:
            return {
                ...state,
                removeDNOResponse: removeDNOResponse,
                isRemoveDNOLoading: false,
                isRemoveDNOSuccess: false,
                isRemoveDNOFail: true
            }
        case REMOVE_DNO_ITEMS_RESET:
            return {
                ...initialState
            }
        default:
            return {
                ...state
            }
    }
}